import { createApiAction } from '@saucelabs/sl-util-redux';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';
import { utils } from '@saucelabs/sl-module-user';

import * as actions from './actions';
import * as api from './api';
import * as constants from './types';
import * as urlQueryString from './../../urlQueryString';
import * as util from './../../util';
import * as selectors from './selectors';
import { OWNER_FILTER_KEYS, DEFAULT_GET_OWNERS_OPTIONS } from '../../constants';

import { operations } from './index';

// get filters
export const getFilters = createApiAction(
  constants.GET_FILTERS,
  (payload, meta, dispatch, getState) => api.getFilters(selectors.getFiltersParams(getState())),
);

export const clearAndGetFilters = (payload, meta) => (dispatch) => {
  dispatch(actions.clearSelectedFilters(payload, meta));
  return dispatch(operations.getFilters());
};

export const selectAndGetFilterItems = (payload, meta) => (dispatch) => {
  dispatch(actions.selectFilterItems(payload, meta));
  return dispatch(operations.getFilters());
};

export const getOwners = (
  selectedOwner, options = DEFAULT_GET_OWNERS_OPTIONS,
) => (dispatch, getState) => {
  const userInfo = selectors.getUserInfo(getState());
  const { username, user } = userInfo;
  const ownerSources = utils.getOwnerSources(user);

  return Promise.all([
    dispatch(actions.fetchOwnersRequest()),
    (ownerSources.addUsername ? dispatch(actions.addUsername(username)) : Promise.resolve()),
    (ownerSources.addTeam ? dispatch(actions.addTeam(user.getUserTeamName())) : Promise.resolve()),
    (ownerSources.addOrganization ? dispatch(actions.addOrganization()) : Promise.resolve()),
    (ownerSources.getOrganizationUsers && options.getOrganizationUsers ? dispatch(
      actions.getOrganizationUsers(username)) : Promise.resolve()
    ),
    (ownerSources.getTeams && options.getTeams ?
      dispatch(actions.getTeams()) : Promise.resolve()),
  ]).then(() => dispatch(actions.fetchOwnersSuccess(selectors.getOwners(getState(), selectedOwner)),
  )).catch((error) => {
    dispatch(notificationActions.notifyDanger(
      error.message, 'We\'ve experienced an issue while fetching owners.', true,
    ));
  });
};

export const searchMetadata = (payload) => (dispatch, getState) => {
  const { filterKey, value } = payload;
  const isQueryValid = value && value.length > 2;
  if (!isQueryValid) {
    return Promise.resolve();
  }

  return Promise.all([
    dispatch(actions.searchMetadataRequest(filterKey)),
    api.searchMetadata(selectors.getMetadataParams(getState(), payload)),
  ]).then((result) => dispatch(actions.searchMetadataSuccess(result[1].data),
  )).catch(() => dispatch(actions.searchMetadataFailure(filterKey)));
};

export const setInitialFilters = (user, location, defaultFilters, ownerOptions) => (dispatch) => {
  const allQueryParams = urlQueryString.getAll(location);
  const combinedFilters = util.getFiltersFromQueryParams(allQueryParams, defaultFilters);
  const { [OWNER_FILTER_KEYS.OWNERS]: ownersFilter = [], ...filters } = combinedFilters;
  const dateFilters = allQueryParams.dateFilter ?
    util.getDateFilterFromQueryParams(allQueryParams) : null;

  return Promise.all([
    ...(Object.keys(filters).length ? [dispatch(actions.setFiltersFromQueryParams(filters))] : []),
    ...(dateFilters ? [dispatch(actions.selectDateFilter(dateFilters))] : []),
    dispatch(operations.getOwners(ownersFilter, ownerOptions)),
  ]);
};
